<template>
  <v-container fill-height fluid color="white">
    <v-row>
      <v-col cols="12" align="center" justify="center">
        <div v-if="meetups.length" >
          <p class="mb-10"><img :src="meetups[0].image" width="40%"></p>
          <p class="mb-10 display-2 font-weight-black">{{ meetups[0].timestamp | timestampToTime }} - {{ endTime(meetups[0].timestamp, meetups[0].duration) | timestampToTime }}</p>
          <!--<p>Продолжительность: {{ meetups[0].duration }} минут</p>-->
          <p class="display-1">{{ meetups[0].description }}</p>
        </div>

        <div v-else>
          <app-slider></app-slider>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import AppSlider from '../Slider/Slider.vue'

  export default {
    data: () => ({
      polling: null,
    }),
    components: {
      AppSlider
    },
    methods:{
      endTime(start, durat){
        return +start + durat * 60 * 1000;
      },
      pollData () {
        this.polling = setInterval(() => {
          this.$store.dispatch('loadMeetups');
        }, 300000)
      }
    },
    computed: {
      meetups(){
        return this.$store.getters.loadedMeetups
              .filter(meetup => meetup.room == this.$route.params.room)
              .filter(meetup => +(new Date().getTime()) < (+meetup.timestamp + meetup.duration * 60 * 1000))
              .reverse();
      },
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    created(){
      this.pollData();
      //this.$store.dispatch('loadMeetups');
    }
  }
</script>

<style scoped>
  .container {
    background-color: #FFF;
    padding: 0;
  }
  .col-12 {
    padding: 0;
  }
</style>
